import { render, staticRenderFns } from "./DefaultHero.vue?vue&type=template&id=e18c329a&scoped=true&"
import script from "./DefaultHero.vue?vue&type=script&lang=js&"
export * from "./DefaultHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18c329a",
  null
  
)

export default component.exports